import React from 'react';
import {MobileRules} from '../Header/RulesModal/MobileRules';
import {ShowFullFixture} from "../Line/ShowFullFixture";
import {Live, LiveTop, LiveWidget} from "../Live/Live";
import {MobileCoupons} from "../coupons/MobileCoupons";
import {SearchComponent} from "../SearchModal/SearchComponent";
import {PrematchFilter} from "../Line/PrematchFilter";
import {DynamicComponent} from "../dynamic/DynamicComponent";
import {Route, Routes, useNavigate} from "react-router-dom";
import {Rating} from "../Line/Rating";
import { PrematchTree } from '../Line/PrematchTree';
import { TreeMaster } from './TreeMaster';

const Favorites = React.lazy(() => import('../Favorites/Favorites'));
const Results = React.lazy(() => import('../Results/Results'));
const MyBets = React.lazy(() => import('../MyBets/MyBets'));

export const Routers = () => {
    const navigate = useNavigate();
    return <>
        <React.Suspense fallback={<div>loading...</div>}>
            <Routes>
                <Route path="/sport">
                    <Route element={<TreeMaster/>}>
                        <Route path={''} element={<DynamicComponent/>}/>
                        <Route path="live-top" element={<LiveTop/>}/>
                        <Route path="live-widget" element={<LiveWidget/>}/>
                        <Route path='live/event/:fixtureId' element={<ShowFullFixture page={'LIVE'}/>}/>
                        <Route path='live/event/mobile/:fixtureId' element={<ShowFullFixture page={'LIVE'}/>}/>
                        <Route path="live/:sportId/:categoryId/:tournamentId" element={<Live/>}/>
                        <Route path="live/:sportId/:categoryId" element={<Live/>}/>
                        <Route path="live/:sportId" element={<Live/>}/>
                        <Route path="live" element={<Live/>}/>

                        {/*LINE*/}
                        <Route path="rating/:sportId/:categoryId/:tournamentId" element={<PrematchFilter/>}/>
                        <Route path="rating/:sportId/:categoryId" element={<PrematchFilter/>}/>
                        <Route path="rating/:sportId" element={<PrematchFilter/>}/>
                        <Route path="rating" element={<Rating/>}/>
                        <Route path='rating/event/:fixtureId' element={<ShowFullFixture page={'RATING'}/>}/>
                        <Route path='rating/event/mobile/:fixtureId' element={<ShowFullFixture page={'RATING'}/>}/>

                        <Route path="prematch" element={<PrematchTree/>}/>
                        <Route path={'not_started/event/:fixtureId'} element={<ShowFullFixture page={'PREMATCH'}/>}/>
                        <Route path={'prematch/event/:fixtureId'} element={<ShowFullFixture page={'PREMATCH'}/>}/>
                        <Route path={'prematch/:sportId/:categoryId/:tournamentId'} element={<PrematchFilter/>}/>
                        <Route path={'prematch/:sportId/:categoryId/'} element={<PrematchFilter/>}/>
                        <Route path={'prematch/:sportId'} element={<PrematchFilter/>}/>
                        <Route path='prematch/event/mobile/:fixtureId' element={<ShowFullFixture page={'PREMATCH'}/>}/>

                        {/*OTHER*/}
                        <Route path={'favorites/event/:fixtureId'} element={<ShowFullFixture page={'FAVORITES'}/>}/>
                        <Route path={'favorites'} element={<Favorites/>}/>
                        <Route path={'my-bets'} element={<MyBets/>}/>
                        <Route path={'results'} element={<Results type={'ALL'}/>}/>
                        <Route path={'steps'} element={<MobileCoupons type={"steps"}/>}/>
                        <Route path={'coupons'} element={<MobileCoupons type={"coupon"}/>}/>
                        <Route path={'rules'} element={<MobileRules/>}/>
                        <Route path={'search'} element={<SearchComponent setOpen={() => {}} char={''} goBack={() => navigate(-1)}/>}/>

                        <Route path={':route'} element={<DynamicComponent/>}/>
                    </Route>

                </Route>
                <Route path={'/'} element={<DynamicComponent/>}/>
                <Route path={':route'} element={<DynamicComponent/>}/>
            </Routes>

        </React.Suspense>
    </>
};
